// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__13_VY","main":"App_main__2YBOb"};